import { render, staticRenderFns } from "./EpfCalculator.vue?vue&type=template&id=a74eb282&scoped=true"
import script from "./EpfCalculator.vue?vue&type=script&lang=js"
export * from "./EpfCalculator.vue?vue&type=script&lang=js"
import style0 from "./EpfCalculator.vue?vue&type=style&index=0&id=a74eb282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74eb282",
  null
  
)

export default component.exports